import { isNumber } from "@datadog/browser-core";
import { Button, Dropdown } from "@fanduel/og-fe-library";
import cx from "classnames";
import { Dispatch, SetStateAction } from "react";
import { RACING_TRACKS_FILTER_APPLIED } from "@/constants/amplitude";
import { useAmplitude } from "@/utils/hooks/useAmplitude";
import styles from "./trackListControls.module.scss";

interface LetterFilterProps {
  filterByLetter: string | null;
  setFilterByLetter: Dispatch<SetStateAction<string | null>>;
}

const supportedLetters = [
  "A",
  "B",
  "C",
  "D",
  "F",
  "G",
  "H",
  "I",
  "J",
  "K",
  "L",
  "M",
  "N",
  "O",
  "P",
  "S",
  "T",
  "U",
  "V",
  "W",
  "Z",
];

const LetterFilter = ({
  filterByLetter,
  setFilterByLetter,
}: LetterFilterProps) => {
  const setSelected: Dispatch<SetStateAction<number>> = (index) => {
    if (index === 0) {
      setFilterByLetter(null);
    }
    if (isNumber(index)) {
      setFilterByLetter(supportedLetters[index - 1]);
    }
  };
  const { logAmplitudeEvent } = useAmplitude();

  return (
    <div>
      <div className={styles.letterContainer}>
        <Button
          className={cx(styles.letter, !filterByLetter && styles.selected)}
          onClick={() => setFilterByLetter(null)}
          buttonStyle="Naked"
          buttonText="All"
        />
        {supportedLetters.map((letter) => (
          <Button
            className={cx(
              styles.letter,
              letter.toLocaleUpperCase() === filterByLetter && styles.selected
            )}
            onClick={() => {
              setFilterByLetter(letter);
              logAmplitudeEvent(RACING_TRACKS_FILTER_APPLIED, {
                Module: "tracks_filters",
                "Filter Name": "starting_letter",
                "Filter Value": letter,
              });
            }}
            key={letter}
            buttonStyle="Naked"
            buttonText={letter}
          />
        ))}
      </div>

      <div className={styles.letterDropdownContainer}>
        <Dropdown
          title="FILTER BY"
          selected={
            filterByLetter ? supportedLetters.indexOf(filterByLetter) + 1 : 0
          }
          options={["All", ...supportedLetters].map((label) => ({ label }))}
          setSelected={setSelected}
        />
      </div>
    </div>
  );
};

export default LetterFilter;
